import { c as _c } from "react/compiler-runtime";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { CREATE_WAVE_GROUPS } from "@/helpers/waves/waves.constants";
import { CreateWaveGroupConfigType, WaveGroupsConfig } from "@/types/waves.types";
import CreateWaveWarning from "../utils/CreateWaveWarning";
import CreateWaveGroup from "./CreateWaveGroup";
export default function CreateWaveGroups(t0) {
  const $ = _c(24);
  const {
    waveType,
    groups,
    onGroupSelect,
    chatEnabled,
    adminCanDeleteDrops,
    groupsCache,
    setChatEnabled,
    setDropsAdminCanDelete
  } = t0;
  const isRestrictedGroup = !!groups.admin && !!groups.canView;
  const t1 = CREATE_WAVE_GROUPS[waveType];
  let t2;
  if ($[0] !== adminCanDeleteDrops || $[1] !== chatEnabled || $[2] !== groups || $[3] !== groupsCache || $[4] !== onGroupSelect || $[5] !== setChatEnabled || $[6] !== setDropsAdminCanDelete || $[7] !== t1 || $[8] !== waveType) {
    let t3;
    if ($[10] !== adminCanDeleteDrops || $[11] !== chatEnabled || $[12] !== groups || $[13] !== groupsCache || $[14] !== onGroupSelect || $[15] !== setChatEnabled || $[16] !== setDropsAdminCanDelete || $[17] !== waveType) {
      t3 = groupType => <CreateWaveGroup key={groupType} groupType={groupType} waveType={waveType} chatEnabled={chatEnabled} groupsCache={groupsCache} groups={groups} adminCanDeleteDrops={adminCanDeleteDrops} setChatEnabled={setChatEnabled} onGroupSelect={group => onGroupSelect({
        group,
        groupType
      })} setDropsAdminCanDelete={setDropsAdminCanDelete} />;
      $[10] = adminCanDeleteDrops;
      $[11] = chatEnabled;
      $[12] = groups;
      $[13] = groupsCache;
      $[14] = onGroupSelect;
      $[15] = setChatEnabled;
      $[16] = setDropsAdminCanDelete;
      $[17] = waveType;
      $[18] = t3;
    } else {
      t3 = $[18];
    }
    t2 = t1.map(t3);
    $[0] = adminCanDeleteDrops;
    $[1] = chatEnabled;
    $[2] = groups;
    $[3] = groupsCache;
    $[4] = onGroupSelect;
    $[5] = setChatEnabled;
    $[6] = setDropsAdminCanDelete;
    $[7] = t1;
    $[8] = waveType;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[19] !== isRestrictedGroup) {
    t3 = isRestrictedGroup && <CreateWaveWarning title="Warning: Limited Access" description={" This wave is configured with restricted access. It can only be viewed\n        and managed by the members of the \"Who can view\" and\n        \"Admin\" groups. If you are not a member of either of these\n        groups, you will not be able to access this wave."} />;
    $[19] = isRestrictedGroup;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== t2 || $[22] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-y-6">{t2}{t3}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}